import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import IntegrationActivity from './IntegrationActivity'
import IntegrationAnalysis from './IntegrationAnalysis'
import IntegrationAutomation from './IntegrationAutomation'


import HubSpotIcon from '../../images/hubspot.png'
import {API, Storage} from 'aws-amplify';
import ActivityStatCard from "./hubspot/activity/ActivityStatCard";
import MarketingCampaignsCard from "./hubspot/activity/MarketingCampaignsCard";
import CampaignsTableCard from "./hubspot/activity/CampaignsTableCard"
import BlogTableCard from "./hubspot/activity/BlogTableCard"
import SimilarTableCard from "./hubspot/activity/SimilarTableCard"
import ModalMarketing from "../../components/ModalMarketing";
import ModalBlank from "../../components/ModalBlank";
import CategoryHeatmapCard from "../../charts/CategoryHeatmapCard"
import HeatmapHubspotCard from "../../charts/HeatmapHubspotCard";
import GroupedBarHubspotCard from "../../charts/GroupedBarHubspotCard";
import DonutHubspotCard from "../../charts/DonutHubspotCard";
import OptimalEmailCard from "./hubspot/activity/OptimalEmailCard";
import AccordionTableHeatmap from "../../components/AccordionTableHeatmap";
import PageCard from "./hubspot/activity/PageCard";

function IntegrationDetail({selectedIntegration, userDetails, authToken, activityData, analysisData}) {
  const items = [
    {
      id: '0',
      image: '',
      customer: 'Mark Cameron',
      total: '$129.00',
      status: 'Refunded',
      items: '1',
      location: '🇲🇽 New Mexico, MX',
      type: 'Subscription',
      description: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
    {
      id: '1',
      image: '',
      customer: 'Mark Cameron',
      total: '$129.00',
      status: 'Refunded',
      items: '1',
      location: '🇲🇽 New Mexico, MX',
      type: 'Subscription',
      description: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    },
  ];
  const [openTab, setOpenTab] = useState(1);
  const [selectedMetric, setSelectedMetric] = useState('cta')
  const [stats, setStats] = useState({});
  const [marketingEmailData, setMarketingEmailData] = useState(null);
  const [optimalEmailData, setOptimalEmailData] = useState(null);
  const [optimalQueryList, setOptimalQueryList] = useState([]);
  const [optimalSentBy, setOptimalSentBy] = useState('');

  const [marketingCTAHeatmapData, setMarketingCTAHeatmapData] = useState(null);
  const [marketingCTABarData, setMarketingCTABarData] = useState(null);
  const [marketingCTADonutData, setMarketingCTADonutData] = useState(null);

  const [marketingUrgencyHeatmapData, setMarketingUrgencyHeatmapData] = useState(null);
  const [marketingUrgencyBarData, setMarketingUrgencyBarData] = useState(null);
  const [marketingUrgencyDonutData, setMarketingUrgencyDonutData] = useState(null);

  const [marketingCampaignHeatmapData, setMarketingCampaignHeatmapData] = useState(null);
  const [marketingCampaignBarData, setMarketingCampaignBarData] = useState(null);
  const [marketingCampaignDonutData, setMarketingCampaignDonutData] = useState(null);

  const [marketingTargetHeatmapData, setMarketingTargetHeatmapData] = useState(null);
  const [marketingTargetBarData, setMarketingTargetBarData] = useState(null);
  const [marketingTargetDonutData, setMarketingTargetDonutData] = useState(null);

  const [marketingPersonalHeatmapData, setMarketingPersonalHeatmapData] = useState(null);
  const [marketingPersonalBarData, setMarketingPersonalBarData] = useState(null);
  const [marketingPersonalDonutData, setMarketingPersonalDonutData] = useState(null);

  const [marketingToneHeatmapData, setMarketingToneHeatmapData] = useState(null);
  const [marketingToneBarData, setMarketingToneBarData] = useState(null);
  const [marketingToneDonutData, setMarketingToneDonutData] = useState(null);

  const [marketingTopicHeatmapData, setMarketingTopicHeatmapData] = useState(null);
  const [marketingTopicBarData, setMarketingTopicBarData] = useState(null);
  const [marketingTopicDonutData, setMarketingTopicDonutData] = useState(null);

  const [marketingHeatmapData, setMarketingHeatmapData] = useState({});
  const [marketingBarData, setMarketingBarData] = useState({});
  const [marketingDonutData, setMarketingDonutData] = useState({});
  const [marketingEmailModalOpen, setMarketingEmailModalOpen] = useState(false)
  const [campaignData, setCampaignData] = useState(null);
  const [campaignDataModalOpen, setCampaignDataModalOpen] = useState(false)
  const [blogPostData, setBlogPostData] = useState(null);
  const [blogPostDataModalOpen, setBlogPostDataModalOpen] = useState(false)
  const [landingPageData, setLandingPageData] = useState(null);
  const [landingPageDataModalOpen, setLandingPageDataModalOpen] = useState(false)
  const [websitePageData, setWebsitePageData] = useState(null);
  const [websitePageDataModalOpen, setWebsitePageDataModalOpen] = useState(false)
  const [similarData, setSimilarData] = useState(null);
  const [similarDataModalOpen, setSimilarDataModalOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState({})
  const [selectedCTAData, setSelectedCTAData] = useState([])
  const [selectedTopicData, setSelectedTopicData] = useState([])
  const [selectedToneData, setSelectedToneData] = useState([])
  const [selectedUrgencyData, setSelectedUrgencyData] = useState([])
  const [selectedCampaignData, setSelectedCampaignData] = useState([])
  const [selectedTargetData, setSelectedTargetData] = useState([])
  const [selectedPersonalData, setSelectedPersonalData] = useState([])
  const color = 'pink'


  const [selectedContextItems, setSelectedContextItems] = useState([])

  function activeTab(tab){
    if(tab!==openTab)
      setOpenTab(tab);
  }

  function updateSelectedContextItems(items){
    setSelectedContextItems(items)
  }

  function viewMarketingEmailDetail(emailData){
    setSelectedItem(emailData)
    setMarketingEmailModalOpen(true)
  }

  function viewCampaignDetail(campaignData){
    setSelectedItem(campaignData)
    setCampaignDataModalOpen(true)
  }

  function viewBlogPostDetail(blogData){
    console.log(blogData)
    setSelectedItem(blogData)
    setBlogPostDataModalOpen(true)
  }

  function updateSelectedMetric(metric){
    setSelectedMetric(metric)
    if(metric === 'cta'){
        setMarketingHeatmapData(marketingCTAHeatmapData)
        setMarketingBarData(marketingCTABarData)
        setMarketingDonutData((marketingCTADonutData))
    }
    else if(metric === 'urgency'){
      setMarketingHeatmapData(marketingUrgencyHeatmapData)
      setMarketingBarData(marketingUrgencyBarData)
      setMarketingDonutData(marketingUrgencyDonutData)
    }
    else if(metric === 'target'){
      setMarketingHeatmapData(marketingTargetHeatmapData)
      setMarketingBarData(marketingTargetBarData)
      setMarketingDonutData((marketingTargetDonutData))
    }
    else if(metric === 'campaign'){
      setMarketingHeatmapData(marketingCampaignHeatmapData)
      setMarketingBarData(marketingCampaignBarData)
      setMarketingDonutData((marketingCampaignDonutData))
    }
    else if(metric === 'personal'){
      setMarketingHeatmapData(marketingPersonalHeatmapData)
      setMarketingBarData(marketingPersonalBarData)
      setMarketingDonutData((marketingPersonalDonutData))
    }
    else if(metric === 'tone'){
      setMarketingHeatmapData(marketingToneHeatmapData)
      setMarketingBarData(marketingToneBarData)
      setMarketingDonutData((marketingToneDonutData))
    }
    else if(metric === 'topic'){
      setMarketingHeatmapData(marketingTopicHeatmapData)
      setMarketingBarData(marketingTopicBarData)
      setMarketingDonutData((marketingTopicDonutData))
    }
    else {
      setMarketingHeatmapData({})
      setMarketingBarData({})
      setMarketingDonutData({})
    }
  }

  function fetchStats(authToken, activeIntegration, user) {
    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'stats',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('stats' in response) {
              setStats(response['stats'])
            }
            else{
              console.log('Stats not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  function fetchMarketingEmails(authToken, activeIntegration, user) {
    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'marketing-emails',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('marketing-emails' in response && 'cta-heatmap' in response && 'cta-bar' in response) {
              setMarketingEmailData(response['marketing-emails'])
              if(response['marketing-emails'].length>0)
                setOptimalSentBy(response['marketing-emails'][Math.floor(Math.random() *
                    response['marketing-emails'].length)].author)
              setMarketingCTAHeatmapData(response['cta-heatmap'])
              setMarketingCTABarData(response['cta-bar'])
              setMarketingCTADonutData(response['cta-donut'])
              setMarketingUrgencyHeatmapData(response['urgency-heatmap'])
              setMarketingUrgencyBarData(response['urgency-bar'])
              setMarketingUrgencyDonutData(response['urgency-donut'])
              setMarketingTargetHeatmapData(response['targ-heatmap'])
              setMarketingTargetBarData(response['targ-bar'])
              setMarketingTargetDonutData(response['targ-donut'])
              setMarketingCampaignHeatmapData(response['campaign-heatmap'])
              setMarketingCampaignBarData(response['campaign-bar'])
              setMarketingCampaignDonutData(response['campaign-donut'])
              setMarketingPersonalHeatmapData(response['personal-heatmap'])
              setMarketingPersonalBarData(response['personal-bar'])
              setMarketingPersonalDonutData(response['personal-donut'])
              setMarketingToneHeatmapData(response['tone-heatmap'])
              setMarketingToneBarData(response['tone-bar'])
              setMarketingToneDonutData(response['tone-donut'])
              setMarketingTopicHeatmapData(response['topic-heatmap'])
              setMarketingTopicBarData(response['topic-bar'])
              setMarketingTopicDonutData(response['topic-donut'])

              /*updateSelectedMetric('cta')*/
              setMarketingHeatmapData(response['cta-heatmap'])
              setMarketingBarData(response['cta-bar'])
              setMarketingDonutData(response['cta-donut'])
              setSelectedMetric('cta')
            }
            else{
              console.log('Marketing email data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  function fetchCampaigns(authToken, activeIntegration, user) {

    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'campaigns',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('campaigns' in response) {
              setCampaignData(response['campaigns'])
            }
            else{
              console.log('Marketing email data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  function fetchBlogPosts(authToken, activeIntegration, user) {

    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'blog-posts',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('blog-posts' in response) {
              setBlogPostData(response['blog-posts'])
            }
            else{
              console.log('Blog posts data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  function fetchLandingPages(authToken, activeIntegration, user) {

    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'landing-pages',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('landing-pages' in response) {
              setLandingPageData(response['landing-pages'])
            }
            else{
              console.log('Landing page data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  function fetchWebPages(authToken, activeIntegration, user) {

    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'website-pages',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('web-pages' in response) {
              setWebsitePageData(response['web-pages'])
            }
            else{
              console.log('Web page data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  function fetchSimilar(authToken, activeIntegration, user) {

    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/integration/query';

      var params = {
        queryStringParameters: {
          integration: activeIntegration.integration.name,
          case: 'similar',
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('similar' in response) {
              setSimilarData(response['similar'])
            }
            else{
              console.log('Web page data not found.')
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  function refreshOptimalEmail(){
    setOptimalEmailData(null)
    if(authToken && selectedIntegration && userDetails)
      fetchOptimalEmail(authToken, selectedIntegration, userDetails)
  }

  function prepareContextItems(){
    var context = ''
    if(selectedContextItems!=null && selectedContextItems.length>0){
      for(var i in selectedContextItems){
        context += '\n context '+(i+1)+': '+selectedContextItems[i].fulltext
      }
    }
    return context
  }

  function fetchOptimalEmail(authToken, activeIntegration, user) {
    if(authToken!=null){
      var apiName = 'DashboardAPI';
      var path = '/nlp/compose/email';

      var params = {
        queryStringParameters: {
          clientDescription: 'offering a call center quality management platform',
          cta: 'purchase',
          urgency: 'hours',
          targetAudience: 'interest',
          campaignType: 'loyalty',
          personalization: 'motivation',
          tone: 'gratitude',
          topic: 'technology',
          context: prepareContextItems(),
          clientId: user.clientId,
          activeIntegrationId: activeIntegration.id
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };
      API.get(apiName, path, params)
          .then(async(response) => {
            if('result' in response && 'choices' in response['result'] && response['result']['choices'].length>0) {
              setOptimalEmailData(response['result']['choices'][0]['text'])
              setOptimalQueryList(['purchase', 'hours', 'gratitude', 'technology'])
              //setOptimalSentBy(user.email)
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });
    }
  }

  useEffect(() => {
    fetchStats(authToken, selectedIntegration, userDetails)
    fetchMarketingEmails(authToken, selectedIntegration, userDetails)
    fetchCampaigns(authToken, selectedIntegration, userDetails)
    fetchBlogPosts(authToken, selectedIntegration, userDetails)
    fetchLandingPages(authToken, selectedIntegration, userDetails)
    fetchWebPages(authToken, selectedIntegration, userDetails)
    fetchSimilar(authToken, selectedIntegration, userDetails)
    fetchOptimalEmail(authToken, selectedIntegration, userDetails)
  }, [selectedIntegration, authToken, activityData, analysisData]);

  useEffect(()=>{
    if(selectedItem!=null) {
      var cta_series = []
      for (const i of Object.keys(selectedItem)) {
        if (i.includes('cta_')) {
          cta_series.push({'x': i.replace('cta_', '').slice(0,10), 'y': selectedItem[i] * 100})
        }
      }
      setSelectedCTAData(cta_series)

      var topic_series = []
      for (const i of Object.keys(selectedItem)) {
        if (i.includes('topic_')) {
          topic_series.push({'x': i.replace('topic_', '').replace('_', ' ').slice(0,10),
            'y': Math.round(selectedItem[i] * 100)})
        }
      }
      topic_series = topic_series.sort((a, b) => (a.y > b.y) ? -1 : 1).slice(0, 11)
      topic_series = topic_series.sort((a, b) => (a.x > b.x) ? 1 : -1)
      setSelectedTopicData(topic_series)

      var tone_series = []
      for (const i of Object.keys(selectedItem)) {
        if (i.includes('tone_')) {
          tone_series.push({'x': i.replace('tone_', '').slice(0,10), 'y': Math.round(selectedItem[i] * 100)})
        }
      }
      tone_series = tone_series.sort((a, b) => (a.y > b.y) ? -1 : 1).slice(0, 11)
      tone_series = tone_series.sort((a, b) => (a.x > b.x) ? 1 : -1)
      setSelectedToneData(tone_series)


      var urgency_series = []
      for (const i of Object.keys(selectedItem)) {
        if (i.includes('urgency_')) {
          urgency_series.push({'x': i.replace('urgency_', '').slice(0,10), 'y': Math.round(selectedItem[i] * 100)})
        }
      }
      urgency_series = urgency_series.sort((a, b) => (a.y > b.y) ? -1 : 1).slice(0, 11)
      urgency_series = urgency_series.sort((a, b) => (a.x > b.x) ? 1 : -1)
      setSelectedUrgencyData(urgency_series)

      var campaign_series = []
      for (const i of Object.keys(selectedItem)) {
        if (i.includes('campaign_')) {
          campaign_series.push({'x': i.replace('campaign_', '').slice(0,10), 'y': Math.round(selectedItem[i] * 100)})
        }
      }
      campaign_series = campaign_series.sort((a, b) => (a.y > b.y) ? -1 : 1).slice(0, 11)
      campaign_series = campaign_series.sort((a, b) => (a.x > b.x) ? 1 : -1)
      setSelectedCampaignData(campaign_series)


      var target_series = []
      for (const i of Object.keys(selectedItem)) {
        if (i.includes('targ_')) {
          target_series.push({'x': i.replace('targ_', '').slice(0,10), 'y': Math.round(selectedItem[i] * 100)})
        }
      }
      target_series = target_series.sort((a, b) => (a.y > b.y) ? -1 : 1).slice(0, 11)
      target_series = target_series.sort((a, b) => (a.x > b.x) ? 1 : -1)
      setSelectedTargetData(target_series)

      var personal_series = []
      for (const i of Object.keys(selectedItem)) {
        if (i.includes('personal_')) {
          personal_series.push({'x': i.replace('personal_', '').slice(0,10), 'y': Math.round(selectedItem[i] * 100)})
        }
      }
      personal_series = personal_series.sort((a, b) => (a.y > b.y) ? -1 : 1).slice(0, 11)
      personal_series = personal_series.sort((a, b) => (a.x > b.x) ? 1 : -1)
      setSelectedPersonalData(personal_series)
    }
  }, [selectedItem])

  return (
    <div className="flex flex-wrap">
      {selectedIntegration!=null && 'insightJobPending' in selectedIntegration && !selectedIntegration.insightJobPending ?
          marketingEmailData!=null?<div className="w-full">

            {/* Content */}

            <div className='w-full'>
              <div className="mb-6">
                <div className="grid grid-cols-12 gap-4 place-content-center">
                  <ActivityStatCard key="1" name="Marketing Emails" stat={stats.marketing}
                                    icon="🚀" onClick={() => activeTab(1)} active={openTab === 1}/>
                  <ActivityStatCard key="2" name="Campaigns" stat={stats.campaign}
                                    icon="🎯" onClick={() => activeTab(2)} active={openTab === 2}/>
                  <ActivityStatCard key="3" name="Blog Posts" stat={stats.blog}
                                    icon="✍️" onClick={() => activeTab(3)} active={openTab === 3}/>
                  <ActivityStatCard key="4" name="Landing Pages" stat={stats.landing}
                                    icon="🛬" onClick={() => activeTab(4)} active={openTab === 4}/>
                  <ActivityStatCard key="5" name="Website Pages" stat={stats.web}
                                    icon="🌐" onClick={() => activeTab(5)} active={openTab === 5}/>
                  <ActivityStatCard key="6" name="Similar Campaigns" stat={stats.similar}
                                    icon="📨" onClick={() => activeTab(6)} active={openTab === 6}/>
                </div>
              </div>
              <hr/>
            </div>
            {
              openTab === 1 ?
                  <div className='w-full'>
                    {marketingEmailData != null ?
                        <ul className="flex flex-wrap mt-4">
                          <li className="m-1">
                            <button className={("inline-flex items-center justify-center text-sm font-medium " +
                                "leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm " +
                                "bg-" + (selectedMetric == "cta" ? "pink-500" : "blue-400") + " text-white duration-150 ease-in-out cursor-pointer")}
                                    onClick={() => updateSelectedMetric('cta')}>Call-to-action
                            </button>
                          </li>
                          <li className="m-1">
                            <button className={"inline-flex items-center justify-center text-sm font-medium " +
                                "leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm " +
                                "bg-" + (selectedMetric == "urgency" ? "pink-500" : "blue-400") + " text-white duration-150 ease-in-out cursor-pointer"}
                                    onClick={() => updateSelectedMetric('urgency')}>Urgency
                            </button>
                          </li>
                          <li className="m-1">
                            <button className={"inline-flex items-center justify-center text-sm font-medium " +
                                "leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm " +
                                "bg-" + (selectedMetric == "target" ? "pink-500" : "blue-400") + " text-white duration-150 ease-in-out cursor-pointer"}
                                    onClick={() => updateSelectedMetric('target')}>Target audience
                            </button>
                          </li>
                          <li className="m-1">
                            <button className={"inline-flex items-center justify-center text-sm font-medium " +
                                "leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm " +
                                "bg-" + (selectedMetric == "campaign" ? "pink-500" : "blue-400") + " text-white duration-150 ease-in-out cursor-pointer"}
                                    onClick={() => updateSelectedMetric('campaign')}>Campaign type
                            </button>
                          </li>
                          <li className="m-1">
                            <button className={"inline-flex items-center justify-center text-sm font-medium " +
                                "leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm " +
                                "bg-" + (selectedMetric == "personal" ? "pink-500" : "blue-400") + " text-white duration-150 ease-in-out cursor-pointer"}
                                    onClick={() => updateSelectedMetric('personal')}>Personalization
                            </button>
                          </li>
                          <li className="m-1">
                            <button className={"inline-flex items-center justify-center text-sm font-medium " +
                                "leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm " +
                                "bg-" + (selectedMetric == "tone" ? "pink-500" : "blue-400") + " text-white duration-150 ease-in-out cursor-pointer"}
                                    onClick={() => updateSelectedMetric('tone')}>Tone
                            </button>
                          </li>
                          <li className="m-1">
                            <button className={"inline-flex items-center justify-center text-sm font-medium " +
                                "leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm " +
                                "bg-" + (selectedMetric == "topic" ? "pink" : "blue") + "-400 text-white duration-150 ease-in-out cursor-pointer"}
                                    onClick={() => updateSelectedMetric('topic')}>Topic
                            </button>
                          </li>
                        </ul> : ''}
                    <div className="overflow-y-hidden max-h-625">
                      <div className="grid grid-cols-7 grid-rows-1 gap-7 max-h-625 overflow-y-hidden">
                        <div className="col-span-4 flex-col max-h-625 overflow-y-hidden">
                          <HeatmapHubspotCard data={marketingHeatmapData} height={220}/>
                          <DonutHubspotCard data={marketingDonutData} height={265}/>
                        </div>
                        <div className="col-span-3 max-h-625 overflow-y-hidden">
                          <GroupedBarHubspotCard data={marketingBarData} height={800}/>
                        </div>
                      </div>
                    </div>
                    <MarketingCampaignsCard data={marketingEmailData}
                                            integrationName={selectedIntegration.name}
                                            viewDetail={viewMarketingEmailDetail}
                                            updateSelectedItems={updateSelectedContextItems}/>
                    <div className="py-3 px-5"><mark className="bg-gold-600
                   text-white rounded-full px-1.5 pb-0.5"><small>Pro Tip</small></mark><small>👆🏿️ select any previous campaigns and hit generate 👇🏿 for
                    a contextual optimal example</small></div>
                    <OptimalEmailCard data={optimalEmailData}
                                      integrationName={selectedIntegration.name}
                                      optimalQuery={optimalQueryList}
                                      refresh={refreshOptimalEmail}
                                      sentBy={optimalSentBy}
                                      selectedContextItems={selectedContextItems}/>
                  </div> :
                  openTab === 2 ?
                      <div>
                        <CampaignsTableCard data={campaignData}
                                            integrationName={selectedIntegration.name}
                                            viewDetail={viewCampaignDetail}/>
                      </div> :
                      openTab === 3 ?
                          <div>
                            <BlogTableCard data={blogPostData}
                                           integrationName={selectedIntegration.name}
                                           viewDetail={viewBlogPostDetail}/>
                          </div> :
                          openTab === 4 ?
                              <div>
                                <BlogTableCard data={landingPageData}
                                               integrationName={selectedIntegration.name}
                                               viewDetail={viewBlogPostDetail}/>
                              </div> :
                              openTab === 5 ?
                                  <div>
                                    <BlogTableCard data={websitePageData}
                                                   integrationName={selectedIntegration.name}
                                                   viewDetail={viewBlogPostDetail}/>
                                  </div> :
                                  openTab === 6 ?
                                      <div>
                                        <SimilarTableCard data={similarData}
                                                          integrationName={selectedIntegration.name}
                                                          viewDetail={viewMarketingEmailDetail}/>
                                      </div> : ''
            }

          </div>

              :
              <div className="flex flex-col w-full mt-10">
                <div className="m-auto p-3">
                  <span className="relative flex h-10 w-10">
                    <span className="animate-ping absolute h-full w-full rounded-full bg-pink-400 opacity-75"></span>
                    <span className="relative rounded-full h-10 w-10 bg-pink-400"></span>
                  </span>
                </div>
                <div className="m-auto">
                  <p className="p-6 animate-bounce">👀 fetching insights..</p>
                </div>
              </div>

          :
          <div className="w-full justify-items-center">
            <div className="w-full text-center">
              EmPushy is analysing your campaigns. You will receive an alert when your insights are ready.
            </div>
          </div>
      }
      <div className="m-1.5">
        {/* Start */}
        {/*marketing email modal*/}
        <ModalMarketing id="marketing-email-modal" modalOpen={marketingEmailModalOpen} setModalOpen={setMarketingEmailModalOpen}
                        maxWidth={"max-w-5xl"}   height={"full"}>
          <div className="relative">
            {/*<img className="w-full" src={ModalImage} width="460" height="200" alt="New on Mosaic" />*/}
            {/* Close button */}
            <button className="absolute top-0 right-0 mt-5 mr-5 text-slate-50 hover:text-yellow-500"
                    onClick={(e) => { e.stopPropagation(); setMarketingEmailModalOpen(false); }}>
              <div className="sr-only">Close</div>
              <svg className="w-4 h-4 fill-current">
                <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
              </svg>
            </button>
          </div>
          <div className="p-5">
            {/* Modal header */}
            <div className="flex items-center mb-2">
              {/*<div className="mb-3">
                <div className="text-xs inline-flex font-medium bg-yellow-100 text-yellow-600 rounded-full text-center px-2.5 py-1">
                  {selectedItem.subject}
                </div>
              </div>*/}
              <img className="rounded-full bg-white mr-2" src={HubSpotIcon} width="36" height="36" />
              <div className="text-lg font-semibold text-slate-800">{selectedItem.subject}</div>
            </div>
            {/* Modal content */}
            <div className="text-sm mb-5 w-full">
              <hr className="my-2"/>
              <div className="py-5 px-10">
                <h1 className="m-auto text-lg font-semibold text-gray-600 py-3">🗐 Content (brief)</h1>
                <p className="text-justify">
                  {selectedItem.fulltext}...
                </p>
              </div>
              <hr className="my-2"/>
              <div className="px-10">
                <h1 className="m-auto text-lg font-semibold text-gray-600 py-3">🔎 Inferred Features</h1>

              </div>
              <div className="overflow-x-auto flex justify-center">
                <table className="table-auto w-full divide-y divide-slate-200">
                  <AccordionTableHeatmap data={selectedCTAData} name={'Call-to-action'} />
                  <AccordionTableHeatmap data={selectedTopicData} name={'Topic'} />
                  <AccordionTableHeatmap data={selectedToneData} name={'Tone'} />
                  <AccordionTableHeatmap data={selectedUrgencyData} name={'Urgency'} />
                  <AccordionTableHeatmap data={selectedCampaignData} name={'Campaign Type'} />
                  <AccordionTableHeatmap data={selectedTargetData} name={'Target Audience'} />
                </table>
              </div>
              <hr className="my-2"/>
              <div className="px-10">
                <h1 className="m-auto text-lg font-semibold text-gray-600 py-3">📊 Performance Metrics</h1>

              </div>
              <div className="grid grid-cols-6 gap-4">
                <ActivityStatCard key="1" name="Associated Campaign Type" stat={selectedItem.type}
                                  icon="🪧"/>
                <ActivityStatCard key="2" name="Sent" stat={selectedItem.counters_sent}
                                  icon="📤"/>
                <ActivityStatCard key="3" name="Deliveries" stat={selectedItem.counters_delivered}
                                  icon="📬"/>
                <ActivityStatCard key="4" name="Opens" stat={selectedItem.counters_open}
                                  icon="👀"/>
                <ActivityStatCard key="5" name="Clicks" stat={selectedItem.counters_click}
                                  icon="☝️"/>
              </div>
            </div>
            {/* Modal footer */}
            <div className="flex flex-wrap justify-end space-x-2">
              <button className="btn-sm bg-yellow-500 hover:bg-yellow-600 text-white"
                      onClick={(e) => { e.stopPropagation(); setMarketingEmailModalOpen(false); }}>
                Close
              </button>
            </div>
          </div>
        </ModalMarketing>
        {/* End */}
        <ModalMarketing id="campaign-modal" modalOpen={campaignDataModalOpen} setModalOpen={setCampaignDataModalOpen}
                        maxWidth={"max-w-5xl"}   height={"775"}>
          <div className="relative">
            {/*<img className="w-full" src={ModalImage} width="460" height="200" alt="New on Mosaic" />*/}
            {/* Close button */}
            <button className="absolute top-0 right-0 mt-5 mr-5 text-slate-50 hover:text-yellow-500"
                    onClick={(e) => { e.stopPropagation(); setCampaignDataModalOpen(false); }}>
              <div className="sr-only">Close</div>
              <svg className="w-4 h-4 fill-current">
                <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
              </svg>
            </button>
          </div>
          <div className="p-5">
            {/* Modal header */}
            <div className="flex items-center mb-2">
              {/*<div className="mb-3">
                <div className="text-xs inline-flex font-medium bg-yellow-100 text-yellow-600 rounded-full text-center px-2.5 py-1">
                  {selectedItem.subject}
                </div>
              </div>*/}
              <img className="rounded-full bg-white mr-2" src={HubSpotIcon} width="36" height="36" />
              <div className="text-lg font-semibold text-slate-800">{selectedItem.subject}</div>
            </div>
            {/* Modal content */}
            <div className="text-sm mb-5 w-full">
              <hr className="my-2"/>
              <div className="py-5 px-10">
                <h1 className="m-auto text-lg font-semibold text-gray-600 py-3">🗐 Content (brief)</h1>
                <p className="text-justify">
                  {selectedItem.fulltext}...
                </p>
              </div>
              <hr className="my-2"/>
              <div className="px-10">
                <h1 className="m-auto text-lg font-semibold text-gray-600 py-3">🔎 Inferred Features</h1>

              </div>
              <div className="overflow-x-auto flex justify-center">
                <table className="table-auto w-full divide-y divide-slate-200">
                  <AccordionTableHeatmap data={selectedCTAData} name={'Call-to-action'} />
                  <AccordionTableHeatmap data={selectedTopicData} name={'Topic'} />
                  <AccordionTableHeatmap data={selectedToneData} name={'Tone'} />
                  <AccordionTableHeatmap data={selectedUrgencyData} name={'Urgency'} />
                  <AccordionTableHeatmap data={selectedCampaignData} name={'Campaign Type'} />
                  <AccordionTableHeatmap data={selectedTargetData} name={'Target Audience'} />
                </table>
              </div>
              <hr className="my-2"/>
            </div>
            {/* Modal footer */}
            <div className="flex flex-wrap justify-end space-x-2">
              <button className="btn-sm bg-yellow-500 hover:bg-yellow-600 text-white"
                      onClick={(e) => { e.stopPropagation(); setCampaignDataModalOpen(false); }}>
                Close
              </button>
            </div>
          </div>
        </ModalMarketing>

        <ModalMarketing id="blog-post-modal" modalOpen={blogPostDataModalOpen} setModalOpen={setBlogPostDataModalOpen}
                        maxWidth={"max-w-5xl"}   height={"775"}>
          <div className="relative">
            {/*<img className="w-full" src={ModalImage} width="460" height="200" alt="New on Mosaic" />*/}
            {/* Close button */}
            <button className="absolute top-0 right-0 mt-5 mr-5 text-slate-50 hover:text-yellow-500"
                    onClick={(e) => { e.stopPropagation(); setBlogPostDataModalOpen(false); }}>
              <div className="sr-only">Close</div>
              <svg className="w-4 h-4 fill-current">
                <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
              </svg>
            </button>
          </div>
          <div className="p-5">
            {/* Modal header */}
            <div className="flex items-center mb-2">
              {/*<div className="mb-3">
                <div className="text-xs inline-flex font-medium bg-yellow-100 text-yellow-600 rounded-full text-center px-2.5 py-1">
                  {selectedItem.subject}
                </div>
              </div>*/}
              <img className="rounded-full bg-white mr-2" src={HubSpotIcon} width="36" height="36" />
              <div className="text-lg font-semibold text-slate-800 line-clamp-1 px-5">{'subject' in selectedItem &&
              selectedItem.subject.includes('.')?
                  selectedItem.subject.split('.')[0]+'.':selectedItem.subject}</div>
            </div>
            {/* Modal content */}
            <div className="text-sm mb-5 w-full">
              <hr className="my-2"/>

              <div className="grid grid-flow-col grid-rows-1 grid-cols-4 gap-6">
                <div className="py-5 px-10 col-span-2">
                  <h1 className="m-auto text-lg font-semibold text-gray-600 py-3">🗐 Content (brief)</h1>
                  <p className="text-justify line-clamp-6">
                    {selectedItem.fulltext}...
                  </p>
                </div>
                <PageCard pageData={selectedItem} viewDetail={null}/>
              </div>
              <hr className="my-2"/>
              <div className="px-10">
                <h1 className="m-auto text-lg font-semibold text-gray-600 py-3">🔎 Inferred Features</h1>

              </div>
              <div className="overflow-x-auto flex justify-center">
                <table className="table-auto w-full divide-y divide-slate-200">
                  <AccordionTableHeatmap data={selectedCTAData} name={'Call-to-action'} />
                  <AccordionTableHeatmap data={selectedTopicData} name={'Topic'} />
                  <AccordionTableHeatmap data={selectedToneData} name={'Tone'} />
                  <AccordionTableHeatmap data={selectedUrgencyData} name={'Urgency'} />
                  <AccordionTableHeatmap data={selectedCampaignData} name={'Campaign Type'} />
                  <AccordionTableHeatmap data={selectedTargetData} name={'Target Audience'} />
                </table>
              </div>
              <hr className="my-2"/>
            </div>
            {/* Modal footer */}
            <div className="flex flex-wrap justify-end space-x-2">
              <button className="btn-sm bg-yellow-500 hover:bg-yellow-600 text-white"
                      onClick={(e) => { e.stopPropagation(); setBlogPostDataModalOpen(false); }}>
                Close
              </button>
            </div>
          </div>
        </ModalMarketing>
      </div>
    </div>
  );
}

export default IntegrationDetail;
